import type { ReactNode } from "react";
import { X } from "lucide-react";
import { cn } from "@/lib/utils";

type Props = {
  open: boolean;
  onClose: () => void;
  title: string;
  children: ReactNode;
  footer?: ReactNode;
  size?: "sm" | "md" | "lg";
};

export function Modal({ open, onClose, title, children, footer, size = "md" }: Props) {
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-50 grid place-items-stretch sm:place-items-center bg-black/40 sm:p-4 animate-fade-in"
      onClick={onClose}
    >
      <div
        className={cn(
          "w-full bg-background border border-border shadow-lifted flex flex-col",
          "h-full sm:h-auto sm:max-h-[85vh] sm:rounded-lg",
          size === "sm" && "sm:max-w-md",
          size === "md" && "sm:max-w-xl",
          size === "lg" && "sm:max-w-3xl",
        )}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between px-4 sm:px-5 py-3 border-b border-border shrink-0">
          <h3 className="font-semibold truncate pr-2">{title}</h3>
          <button
            onClick={onClose}
            className="h-9 w-9 sm:h-7 sm:w-7 grid place-items-center rounded hover:bg-muted shrink-0"
            aria-label="Đóng"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
        <div className="flex-1 overflow-y-auto p-4 sm:p-5">{children}</div>
        {footer && (
          <div className="px-4 sm:px-5 py-3 border-t border-border flex items-center justify-end gap-2 flex-wrap shrink-0">
            {footer}
          </div>
        )}
      </div>
    </div>
  );
}
